import { ReleaseNoteResponseDTO } from "typings/dto/releaseNote";
import Mapper from "./Mapper";

export default class ReleaseNoteMapper extends Mapper<ReleaseNote, ReleaseNoteResponseDTO>{
  constructor(){
    super({
      href: 'href',
      releaseDate: 'releaseDate',
      title: 'title'
    })
  }
}